import { useViewContext } from "@editor-providers";
import { useGetUserOnSlide } from "../hooks";
import { CollaborationEnabledProvider } from "../providers";

export const CoeditingThumbnailOutline = ({ id }: { id: string }) => {
  const { view } = useViewContext();
  if (view !== "thumbnail") return null;
  return (
    <CollaborationEnabledProvider>
      <Content id={id} />
    </CollaborationEnabledProvider>
  );
};

const Content = ({ id }: { id: string }) => {
  const user = useGetUserOnSlide(id);
  if (!user) return null;

  return (
    <div
      className="tw-pointer-events-none tw-absolute tw-inset-0 tw-size-full tw-rounded-md tw-outline tw-outline-2"
      style={{
        outlineColor: user.color,
      }}
    ></div>
  );
};
